import { useState } from "react";
import { Menu, X } from "lucide-react";
import { NAV_LINKS } from "@/data/siteData";

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 bg-white border-b-2 border-[#0B1120]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 flex items-center justify-between h-20">
        <a href="#start" data-testid="nav-logo-link" className="flex items-center gap-3">
          <img src="/logo.png" alt="Logo SMP Wichniarek" className="h-12 w-12 object-contain" />
          <div className="leading-tight">
            <span className="block font-display font-black uppercase tracking-tight text-[#0B1120] text-base">SMP Wichniarek</span>
            <span className="block font-accent text-[10px] uppercase tracking-widest text-blue-700">Szkółka Młodego Piłkarza</span>
          </div>
        </a>

        <nav data-testid="nav-desktop" className="hidden lg:flex items-center gap-7">
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.href.replace('#', '')}`}
              className="font-accent text-sm font-bold uppercase tracking-wide text-[#0B1120] hover:text-blue-700 transition-colors duration-200"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#kontakt"
            data-testid="nav-cta-button"
            className="bg-[#FACC15] text-[#0B1120] font-display font-black uppercase tracking-tight px-6 py-3 border-2 border-[#0B1120] shadow-[4px_4px_0_#0B1120] hover:translate-x-[2px] hover:translate-y-[2px] hover:shadow-[2px_2px_0_#0B1120] transition-transform duration-150"
          >
            Zapisz się
          </a>
        </nav>

        <button
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen(!open)}
          className="lg:hidden p-2 text-[#0B1120]"
          aria-label="Menu"
        >
          {open ? <X size={28} /> : <Menu size={28} />}
        </button>
      </div>

      {open && (
        <nav data-testid="nav-mobile" className="lg:hidden bg-white border-t border-slate-200 px-4 py-4 flex flex-col gap-3">
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-mobile-link-${l.href.replace('#', '')}`}
              onClick={() => setOpen(false)}
              className="font-accent text-base font-bold uppercase tracking-wide text-[#0B1120] py-2 border-b border-slate-100"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#kontakt"
            data-testid="nav-mobile-cta-button"
            onClick={() => setOpen(false)}
            className="mt-2 text-center bg-[#FACC15] text-[#0B1120] font-display font-black uppercase px-6 py-3 border-2 border-[#0B1120]"
          >
            Zapisz się
          </a>
        </nav>
      )}
    </header>
  );
}
